import { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { postBPDataWithoutParams } from 'src/business/services'
import { LoadingSpinner } from 'src/consumer/components/Loaders'
import { GenericHeaderBackButton } from 'src/consumer/components/UserActivityPage/MyPlanComponents'
import { getDataWithoutParams } from 'src/consumer/services/featureServices'
import { ClinicDataContext } from '../../../context/ClinicDataContext'
import ClinicHeader from '../ClinicHeader'
import {
  AvailabilityPageContainer,
  CARPContainer,
  CARPInternalContainer,
} from './ClinicAssistantResponsibilitiesPageStyles'
import { Dialog, IconButton, Popover } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { Spinner } from 'react-bootstrap'
import Checkbox from '@mui/material/Checkbox'
import DeleteIcon from '@mui/icons-material/Delete'
import Select from 'react-select'
import { isCommonResponseSuccessful } from 'src/mentor/helpers/utilityFunctions'

export default function ClinicAssistantResponsibilitiesPage() {
  const { clinicId, clinicBrandId } = useParams()
  const { ownerData } = useContext(ClinicDataContext)

  const [loading, setLoading] = useState()

  const [assistantsForThisClinic, setAssistantsForThisClinic] = useState()
  const [assistantsMapForThisClinic, setAssistantsMapForThisClinic] = useState()

  // form
  const [dialogOpen, setDialogOpen] = useState(false)
  const [clickedUserData, setClickedUserData] = useState()
  const [clickedUserAssistantData, setClickedUserAssistantData] = useState([])

  const thisClinicData = {
    ...ownerData?.associatedClinicsData?.find((item) => item?.id === clinicId),
    apiParam: 'clinic-profile',
  }

  async function getAndSetInitialData() {
    const resp = await getDataWithoutParams(
      `/api/secure/cp/clinic-assistant/list?id=${clinicId}&type=clinic`,
    )
    // or id=clinicBrandId and type=clinic-brand
    if (resp?.status === 200) {
      const assistantsForThisClinicResponseData = resp?.data || []
      setAssistantsForThisClinic(assistantsForThisClinicResponseData)
      const userMap = {}
      assistantsForThisClinicResponseData?.forEach((item) => {
        if (item.userId in userMap) {
          userMap[item.userId].push(item)
        } else {
          userMap[item.userId] = [item]
        }
      })
      setAssistantsMapForThisClinic(userMap)
    }
  }

  async function setDataFunc() {
    setLoading(true)
    await getAndSetInitialData()
    setLoading(false)
  }

  useEffect(() => {
    setDataFunc()
  }, [])

  if (loading) {
    return <LoadingSpinner bgColor="#F5F5F599" dark />
  } else {
    return (
      <AvailabilityPageContainer>
        <ClinicHeader heading={`${thisClinicData?.name || thisClinicData?.title || ''} | Workforce`} />
        <GenericHeaderBackButton
          clickfunction={() => window.history.back()}
          styles={{ margin: '20px' }}
        />
        <CARPContainer>
          <div style={{ fontSize: '22px' }}>
            <b>Clinic Assistant - Responsibilities</b>
          </div>
          <div style={{ margin: '20px 0', minWidth: '500px' }}>
            <CARPInternalContainer isFirstRow>
              <div>
                <b>User</b>
              </div>
              <div>
                <b>Assistant for Doctors</b>
              </div>
              <div>
                <b>Assistant for Therapists</b>
              </div>
              <div></div>
            </CARPInternalContainer>
            {assistantsMapForThisClinic &&
              Object.keys(assistantsMapForThisClinic)?.map((item, index) => {
                const userSummaryForThisUser = ownerData?.ownerBrandPeopleUserSummary?.[
                  clinicBrandId
                ]?.find((person) => person?.userId === item)
                const clinicAssistantDataForThisUser = assistantsMapForThisClinic?.[item]?.[0]
                const doctorSupportRolesForThisUser = createDoctorsSupportRolesArrayForThisUser(
                  thisClinicData?.doctors || [],
                  clinicAssistantDataForThisUser?.supportRoles || [],
                )
                const therapistSupportRolesForThisUser =
                  createTherapistsSupportRolesArrayForThisUser(
                    thisClinicData?.therapists || [],
                    clinicAssistantDataForThisUser?.supportRoles || [],
                  )
                return (
                  <CARPInternalContainer key={index}>
                    <div>
                      {userSummaryForThisUser?.firstName ||
                        userSummaryForThisUser?.name ||
                        userSummaryForThisUser?.email}
                    </div>
                    <div>
                      {doctorSupportRolesForThisUser?.map(
                        (doctorSupportRoleData, doctorSupportRoleDataIndex) => {
                          const thisDoctorData = ownerData?.ownerBrandMentorsData?.[
                            clinicBrandId
                          ]?.find((mentor) => mentor?.id === doctorSupportRoleData?.managerId)
                          return (
                            <div key={doctorSupportRoleDataIndex}>
                              {thisDoctorData?.name ||
                                thisDoctorData?.firstName ||
                                thisDoctorData?.title ||
                                doctorSupportRoleData?.managerEmailId}
                            </div>
                          )
                        },
                      )}
                    </div>
                    <div>
                      {therapistSupportRolesForThisUser?.map(
                        (therapistSupportRoleData, therapistSupportRoleDataIndex) => {
                          const thisTherapistData = ownerData?.ownerBrandMentorsData?.[
                            clinicBrandId
                          ]?.find((mentor) => mentor?.id === therapistSupportRoleData?.managerId)
                          return (
                            <div key={therapistSupportRoleDataIndex}>
                              {thisTherapistData?.name ||
                                thisTherapistData?.firstName ||
                                thisTherapistData?.title ||
                                therapistSupportRoleData?.managerEmailId}
                            </div>
                          )
                        },
                      )}
                    </div>
                    <button
                      style={{
                        background: 'green',
                        color: 'white',
                        fontWeight: '500',
                        padding: '4px 3px',
                        borderRadius: '4px',
                        maxWidth: '250px',
                        maxHeight: '40px',
                      }}
                      onClick={() => {
                        setDialogOpen(true)
                        setClickedUserData(userSummaryForThisUser)
                        setClickedUserAssistantData(clinicAssistantDataForThisUser)
                      }}
                    >
                      Manage
                    </button>
                  </CARPInternalContainer>
                )
              })}
          </div>
          {dialogOpen && (
            <AssistantEditDialog
              open={dialogOpen}
              closeFunc={() => setDialogOpen(false)}
              thisUserData={clickedUserData}
              thisClinicData={thisClinicData}
              clickedUserAssistantData={clickedUserAssistantData}
              ownerData={ownerData}
              clinicId={clinicId}
              clinicBrandId={clinicBrandId}
              refreshAllData={getAndSetInitialData}
            />
          )}
        </CARPContainer>
      </AvailabilityPageContainer>
    )
  }
}

const AssistantEditDialog = ({
  open,
  closeFunc,
  thisUserData,
  thisClinicData,
  clickedUserAssistantData,
  ownerData,
  clinicId,
  clinicBrandId,
  refreshAllData,
}) => {
  const [saveLoading, setSaveLoading] = useState()
  const [otherDoctorsInClinic, setOtherDoctorsInClinic] = useState()
  const [otherTherapistsInClinic, setOtherTherapistsInClinic] = useState()
  const [localStateOfClinicAssistantObject, setLocalStateOfClinicAssistantObject] = useState()

  const [clickedAddButtonAnchor, setClickedAddButtonAnchor] = useState(null)
  const [clickedAddButtonType, setClickedAddButtonType] = useState(null)

  useEffect(() => {
    setLocalStateOfClinicAssistantObject(clickedUserAssistantData)
  }, [clickedUserAssistantData])

  useEffect(() => {
    const allClinicDoctors = thisClinicData?.doctors || []
    const otherDoctorsInClinic = []
    allClinicDoctors?.forEach((clinicDoctor) => {
      if (
        localStateOfClinicAssistantObject?.supportRoles?.some(
          (activeSupportRole) =>
            activeSupportRole?.managerId === clinicDoctor?.id ||
            activeSupportRole?.managerId === clinicDoctor?.uid ||
            (activeSupportRole?.managerEmailId ? activeSupportRole?.managerEmailId === clinicDoctor?.email : false)
        )
      ) {
      } else {
        otherDoctorsInClinic.push(clinicDoctor)
      }
    })
    setOtherDoctorsInClinic(otherDoctorsInClinic)

    const allClinicTherapists = thisClinicData?.therapists || []
    const otherTherapistsInClinic = []
    allClinicTherapists?.forEach((clinicTherapist) => {
      if (
        localStateOfClinicAssistantObject?.supportRoles?.some(
          (activeSupportRole) =>
            activeSupportRole?.managerId === clinicTherapist?.id ||
            activeSupportRole?.managerId === clinicTherapist?.uid ||
            (activeSupportRole?.managerEmailId ? activeSupportRole?.managerEmailId === clinicTherapist?.email : false)
        )
      ) {
      } else {
        otherTherapistsInClinic.push(clinicTherapist)
      }
    })
    setOtherTherapistsInClinic(otherTherapistsInClinic)
  }, [localStateOfClinicAssistantObject])

  async function saveClinicAssistantResponsibility() {
    setSaveLoading(true)
    const responseSaveProfile = await postBPDataWithoutParams(
      '/api/secure/cp/clinic-assistant/save',
      localStateOfClinicAssistantObject,
    )
    await refreshAllData()
    setSaveLoading(false)
    if (responseSaveProfile?.status === 200 && isCommonResponseSuccessful(responseSaveProfile?.data?.code)) {
      toast.success('Saved Details')
      closeFunc()
    } else {
      toast.error('Please try again')
    }
  }

  function handleCheckboxChange(supportRoleData, checkState) {
    let updatedSupportRoles = [...localStateOfClinicAssistantObject?.supportRoles] || []
    let indexToChange = updatedSupportRoles.findIndex(
      (item) =>
        item?.managerId === supportRoleData?.managerId ||
        (supportRoleData?.managerEmailId
          ? item?.managerEmailId === supportRoleData?.managerEmailId
          : false),
    )
    if (indexToChange > -1) {
      updatedSupportRoles[indexToChange].canPrintPrescription = checkState
      setLocalStateOfClinicAssistantObject((prev) => {
        return { ...prev, supportRoles: updatedSupportRoles }
      })
    }
  }

  function handleDelete(supportRoleData) {
    let updatedSupportRoles = [...localStateOfClinicAssistantObject?.supportRoles] || []
    let indexToChange = updatedSupportRoles.findIndex(
      (item) =>
        item?.managerId === supportRoleData?.managerId ||
        (supportRoleData?.managerEmailId
          ? item?.managerEmailId === supportRoleData?.managerEmailId
          : false),
    )
    if (indexToChange > -1) {
      updatedSupportRoles.splice(indexToChange, 1)
      setLocalStateOfClinicAssistantObject((prev) => {
        return { ...prev, supportRoles: updatedSupportRoles }
      })
    }
  }

  function addNew(data, type) {
    let toAdd = { roleId: 'bookingManager', canPrintPrescription: false }
    if(data?.id || data?.uid){
      toAdd = {...toAdd, managerId: data?.id || data?.uid}
    }
    if(data?.email){
      toAdd = {...toAdd, managerEmailId: data?.email}
    }
    const updatedSupportRoles = [...localStateOfClinicAssistantObject?.supportRoles]
    if(type === 'doctor'){
      updatedSupportRoles.push(toAdd)
    } else if (type=== 'therapist'){
      updatedSupportRoles.push(toAdd)
    }
    setLocalStateOfClinicAssistantObject(prev => ({...prev, supportRoles: updatedSupportRoles}))
    setClickedAddButtonAnchor(null)
  }

  console.log(localStateOfClinicAssistantObject)
  console.log(otherDoctorsInClinic)
  console.log(otherTherapistsInClinic)
  // console.log(ownerData?.ownerBrandMentorsData?.[clinicBrandId])

  return (
    <Dialog
      open={open}
      onClose={closeFunc}
      PaperProps={{
        sx: { padding: '20px' },
      }}
    >
      <div style={{ minWidth: '500px' }}>
        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <CloseIcon style={{ cursor: 'pointer' }} onClick={closeFunc} />
        </div>
        <div style={{ fontSize: '20px', marginTop: '20px' }}>
          For {thisUserData?.firstName || thisUserData?.name || thisUserData?.email}
        </div>
        <div
          style={{ width: '100%', height: '1px', background: '#cecece', margin: '10px 0' }}
        ></div>
        <div style={{ fontSize: '20px' }}>Responsible for Doctors:</div>
        <div>
          {createDoctorsSupportRolesArrayForThisUser(
            thisClinicData?.doctors || [],
            localStateOfClinicAssistantObject?.supportRoles || [],
          )?.map((doctorSupportRoleData, doctorSupportRoleDataIndex) => {
            const thisDoctorData = ownerData?.ownerBrandMentorsData?.[clinicBrandId]?.find(
              (mentor) => mentor?.id === doctorSupportRoleData?.managerId,
            )
            return (
              <div key={doctorSupportRoleDataIndex} style={{ padding: '10px 0' }}>
                <div>
                  {doctorSupportRoleDataIndex + 1}.{' '}
                  {thisDoctorData?.name ||
                    thisDoctorData?.firstName ||
                    thisDoctorData?.title ||
                    doctorSupportRoleData?.managerEmailId}
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div>
                    Can print Prescription?{' '}
                    <Checkbox
                      checked={doctorSupportRoleData?.canPrintPrescription}
                      onChange={(e) =>
                        handleCheckboxChange(doctorSupportRoleData, e.target.checked)
                      }
                      inputProps={{ 'aria-label': 'controlled' }}
                    />
                  </div>
                  <div>
                    <IconButton color="error" onClick={() => handleDelete(doctorSupportRoleData)}>
                      <DeleteIcon />
                    </IconButton>
                  </div>
                </div>
              </div>
            )
          })}
          {otherDoctorsInClinic?.length > 0 && (
            <div style={{ display: 'flex', justifyContent: 'right' }}>
              <AddButton
                clickFunction={(event) => {
                  setClickedAddButtonAnchor(event.currentTarget)
                  setClickedAddButtonType('doctor')
                }}
              />
            </div>
          )}
        </div>
        <div style={{ fontSize: '20px', marginTop: '20px' }}>Responsible for Therapists:</div>
        <div>
          {createTherapistsSupportRolesArrayForThisUser(
            thisClinicData?.therapists || [],
            localStateOfClinicAssistantObject?.supportRoles || [],
          )?.map((therapistSupportRoleData, therapistSupportRoleDataIndex) => {
            const thisTherapistData = ownerData?.ownerBrandMentorsData?.[clinicBrandId]?.find(
              (mentor) => mentor?.id === therapistSupportRoleData?.managerId,
            )
            return (
              <div key={therapistSupportRoleDataIndex} style={{ padding: '10px 0' }}>
                <div>
                  {therapistSupportRoleDataIndex + 1}.{' '}
                  {thisTherapistData?.name ||
                    thisTherapistData?.firstName ||
                    thisTherapistData?.title ||
                    therapistSupportRoleData?.managerEmailId}
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div>
                    Can print Prescription?{' '}
                    <Checkbox
                      checked={therapistSupportRoleData?.canPrintPrescription}
                      onChange={(e) =>
                        handleCheckboxChange(therapistSupportRoleData, e.target.checked)
                      }
                      inputProps={{ 'aria-label': 'controlled' }}
                    />
                  </div>
                  <div>
                    <IconButton
                      color="error"
                      onClick={() => handleDelete(therapistSupportRoleData)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </div>
                </div>
              </div>
            )
          })}
          {otherTherapistsInClinic?.length > 0 && (
            <div style={{ display: 'flex', justifyContent: 'right' }}>
              <AddButton
                clickFunction={(event) => {
                  setClickedAddButtonAnchor(event.currentTarget)
                  setClickedAddButtonType('therapist')
                }}
              />
            </div>
          )}
        </div>
        <div
          style={{ width: '100%', height: '1px', background: '#cecece', margin: '10px 0' }}
        ></div>
        <button
          style={{
            background: 'green',
            color: '#fff',
            fontWeight: '500',
            padding: '4px 8px',
            borderRadius: '4px',
          }}
          onClick={saveClinicAssistantResponsibility}
        >
          {saveLoading ? <Spinner animation="border" variant="light" size="sm" /> : 'Save'}
        </button>
        <Popover
          id="newAddition"
          anchorEl={clickedAddButtonAnchor}
          open={Boolean(clickedAddButtonAnchor)}
          onClose={() => setClickedAddButtonAnchor(null)}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'center',
            horizontal: 'right',
          }}
        >
          <AdditionSelectionComponent
            addNewFunc={addNew}
            type={clickedAddButtonType}
            otherDoctorsInClinic={otherDoctorsInClinic}
            otherTherapistsInClinic={otherTherapistsInClinic}
            allKnownMentorsInThisBrand={ownerData?.ownerBrandMentorsData?.[clinicBrandId]}
          />
        </Popover>
      </div>
    </Dialog>
  )
}

function createDoctorsSupportRolesArrayForThisUser(doctors, supportRoles) {
  const toReturn = []
  supportRoles?.forEach((supportRole) => {
    if (
      doctors?.some(
        (doctor) =>
          doctor?.id === supportRole?.managerId || (supportRole?.managerEmailId ? doctor?.email === supportRole?.managerEmailId : false),
      )
    ) {
      toReturn.push(supportRole)
    }
  })
  return toReturn
}

function createTherapistsSupportRolesArrayForThisUser(therapists, supportRoles) {
  const toReturn = []
  supportRoles?.forEach((supportRole) => {
    if (
      therapists?.some(
        (therapist) =>
          therapist?.id === supportRole?.managerId ||
          (supportRole?.managerEmailId ? therapist?.email === supportRole?.managerEmailId : false),
      )
    ) {
      toReturn.push(supportRole)
    }
  })
  return toReturn
}

const AddButton = ({ clickFunction }) => {
  return (
    <button
      style={{
        backgroundColor: '#ffd300',
        height: '35px',
        width: '35px',
        borderRadius: '50%',
        fontSize: '25px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      onClick={clickFunction}
    >
      +
    </button>
  )
}

const AdditionSelectionComponent = ({
  type,
  addNewFunc,
  otherDoctorsInClinic,
  otherTherapistsInClinic,
  allKnownMentorsInThisBrand,
}) => {
  const [modifiedDoctorsInClinic, setModifiedDoctorsInClinic] = useState()
  const [modifiedTherapistsInClinic, setModifiedTherapistsInClinic] = useState()

  useEffect(() => {
    otherDoctorsInClinic?.forEach((item, index) => {
      otherDoctorsInClinic[index] = { ...item, uniqueId: item?.id || item?.uid || item?.email }
      setModifiedDoctorsInClinic(otherDoctorsInClinic)
    })
    otherTherapistsInClinic?.forEach((item, index) => {
      otherTherapistsInClinic[index] = { ...item, uniqueId: item?.id || item?.uid || item?.email }
      setModifiedTherapistsInClinic(otherTherapistsInClinic)
    })
  }, [])

  return (
    <div style={{ padding: '20px', minWidth: '300px' }}>
      <Select
        className="basic-single"
        classNamePrefix="select"
        isSearchable={true}
        name="select mentor"
        getOptionValue={(option) => option?.uniqueId}
        getOptionLabel={(option) => {
          const thisMentorData = allKnownMentorsInThisBrand?.find(
            (item) => item?.id === option?.id || item?.id === option?.uid,
          )
          return (
            thisMentorData?.name ||
            thisMentorData?.firstName ||
            thisMentorData?.title ||
            option?.email
          )
        }}
        options={type === 'doctor' ? modifiedDoctorsInClinic : modifiedTherapistsInClinic}
        placeholder="Select"
        onChange={(newVal) => addNewFunc(newVal, type)}
        menuPortalTarget={document.body}
        menuPlacement="auto"
        styles={{
          menuPortal: (styles) => ({ ...styles, zIndex: 9999 }),
          option: (styles, state) => ({
            ...styles,
            cursor: state.isDisabled ? 'not-allowed' : 'pointer',
            color: state.isDisabled ? styles.color : styles.color,
            backgroundColor: state.isDisabled ? styles.backgroundColor : styles.backgroundColor,
          }),
          control: (styles, state) => ({
            ...styles,
            cursor: state.isDisabled ? 'not-allowed' : 'pointer',
            color: state.isDisabled ? styles.color : styles.color,
            backgroundColor: state.isDisabled ? styles.backgroundColor : styles.backgroundColor,
          }),
        }}
      />
    </div>
  )
}
